import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shop",
  "use": "icon-shop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shop\"><defs><style type=\"text/css\"></style></defs><path d=\"M853.333 85.333H170.667c-46.933 0-85.333 38.4-85.333 85.333v682.667c0 46.933 38.4 85.333 85.333 85.333h682.667c46.933 0 85.333-38.4 85.333-85.333V170.667c0-46.933-38.4-85.334-85.333-85.334z m0 768H170.667V170.667h682.667v682.666z\" p-id=\"2118\" fill=\"currentColor\" /><path d=\"M341.333 341.333h341.333v85.333H341.333v-85.333zM341.333 512h341.333v85.333H341.333V512zM341.333 682.667h256v85.333H341.333v-85.333z\" p-id=\"2119\" fill=\"currentColor\" /><path d=\"M256 256h85.333v85.333H256V256zM256 426.667h85.333v85.333H256v-85.333zM256 597.333h85.333v85.333H256v-85.333z\" p-id=\"2120\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shop.svg
// module id = hert
// module chunks = 29